import { render } from "./YamlInputField.vue?vue&type=template&id=05961481&scoped=true"
import script from "./YamlInputField.vue?vue&type=script&lang=js"
export * from "./YamlInputField.vue?vue&type=script&lang=js"

import "./YamlInputField.vue?vue&type=style&index=0&id=05961481&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05961481"]])

export default __exports__